export default __webpack_public_path__ + "static/tplo-plan-illu-d230db448e9a51acb831eb349a4ebc3c.jpg";